
import { useState, useEffect } from 'react';
import { supabase } from "@/integrations/supabase/client";
import { addMonths, isBefore } from "date-fns";

interface ExpiringGuard {
  id: string;
  first_name: string;
  last_name: string;
  license_expiry_date: string;
}

export const useExpiringLicenses = () => {
  const [expiringGuards, setExpiringGuards] = useState<ExpiringGuard[]>([]);

  useEffect(() => {
    const checkExpiringLicenses = async () => {
      const threeMonthsFromNow = addMonths(new Date(), 3);
      
      const { data: guards, error } = await supabase
        .from('profiles')
        .select('id, first_name, last_name, license_expiry_date')
        .eq('status', 'active')
        .not('license_expiry_date', 'is', null);

      if (error) {
        console.error('Error fetching guards:', error);
        return;
      }

      const expiringGuardsList = guards.filter(guard => {
        if (!guard.license_expiry_date) return false;
        const expiryDate = new Date(guard.license_expiry_date);
        return isBefore(expiryDate, threeMonthsFromNow);
      });

      setExpiringGuards(expiringGuardsList);
    };

    checkExpiringLicenses();

    // Check every hour for updates
    const interval = setInterval(checkExpiringLicenses, 3600000);

    return () => clearInterval(interval);
  }, []);

  return {
    expiringGuards,
    expiringCount: expiringGuards.length
  };
};
